export const loading = async ({ start, done } = {}, func = () => {}) => {
  if (typeof start === 'function') {
    start();
  }
  const res = await func();
  if (typeof done === 'function') { done(); }
  return res;
};

export default loading;